import JobWorkerNotInterestedReason from "@/models/JobWorkers/JobWorkerNotInterestedReason";
import JobContactNotInterestedReason from "@/models/JobWorkers/JobContactNotInterestedReason";
import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateJobWorkerStatusContactInterestedRequest extends BaseUpdateRequest  { 
    jobWorkerId = '';
    interested = false;
    moveToInterviewOne = false;
    notInterestedReason: JobContactNotInterestedReason = 0;
}
